import ButtonLink from 'components/ui/ButtonLink'

const CtaSection = () => (
  <div className="py-12 bg-gradient-to-r from-orange-600 to-orange-800">
    <div className="mx-auto max-w-screen-md lg:max-w-7xl px-8">
      <h2 className="md:text-4xl text-3xl tracking-wide my-8 font-bold text-center text-white">
        Want to book these vendors for an event?
      </h2>
      <div className="prose prose-xl text-center mx-auto mb-4">
        <p className="text-white">
          If you&apos;re looking to book vendors for a catering event or office
          lunch, we&apos;ll set up everything for you.
        </p>
      </div>
      <div className="text-center mx-auto">
        <ButtonLink
          color="primary"
          href="/hire-food-truck"
          prefetch={false}
          size="large"
          variant="outline"
        >
          Get a free quote
        </ButtonLink>
      </div>
    </div>
  </div>
)

export default CtaSection
